import React from "react";
import { Link } from "gatsby";

const MainMenuLink = ({ data, index }) => {
  const item = data;
  console.info("MainMenuLink", item);
  return (
    <Link
      to={`/${item.page.data.attributes.Slug}`}
      className=" lg:text-white text-teal font-bold sm:text-lg font-display hover:text-orange"
    >
      {item.Title}
    </Link>
  );
};
export default MainMenuLink;
